import { motion } from "framer-motion";
import { Media } from "@/components/Media";

const EASE = [0.16, 1, 0.3, 1];

export const Factory = () => (
  <section id="factory" className="relative h-[92vh] sm:h-[105vh] overflow-hidden" data-testid="factory-section">
    <Media
      video="/media/factory.mp4"
      poster="/media/factory.png"
      alt="SANTELQ Hubs being built on a bright production line"
      testid="factory-media"
    />
    <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black/35 via-black/10 to-transparent pointer-events-none" />
    <div className="absolute bottom-8 left-5 sm:bottom-14 sm:left-14 max-w-md">
      <motion.div
        initial={{ opacity: 0, y: 48 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-18%" }}
        transition={{ duration: 1.1, ease: EASE }}
        className="backdrop-blur-xl bg-white/75 border border-white/50 rounded-3xl p-7 sm:p-9 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.25)]"
        data-testid="factory-card"
      >
        <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#808080]">The Factory</p>
        <h3 className="font-display font-semibold tracking-tight text-[#3A3A3C] text-xl sm:text-2xl leading-[1.15] mt-3">
          Built like hospital equipment.
        </h3>
        <p className="text-sm sm:text-base text-[#474747] leading-relaxed mt-4">
          Every Hub is assembled piece by piece, then tested again and again before it ships to your facility.
        </p>
      </motion.div>
    </div>
  </section>
);
